import anchor from '@alpinejs/anchor';
import alpineFocus from '@alpinejs/focus';
import persist from '@alpinejs/persist';
import Alpine from 'alpinejs';

import tracking from './tracking.ts';
import xNoscroll from './x-noscroll.js';

Alpine.plugin(anchor);
Alpine.plugin(alpineFocus);
Alpine.plugin(persist);
Alpine.plugin(xNoscroll);
Alpine.plugin(tracking);

Alpine.store('currencyConversion', {
    currency: Alpine.$persist(null),
});

export default Alpine;
